module.exports = __webpack_public_path__ + "static/media/sistemaPegar13.c59e8037.jpg";